import React from 'react';

import MojitoCore from 'mojito/core';
import MojitoApplications from 'mojito/applications';
import MojitoPresentation from 'mojito/presentation';

const UIPage = MojitoCore.Presentation.UIPage;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const UIViewUtils = MojitoCore.Presentation.UIViewUtils;
const Button = MojitoPresentation.Components.Button;
const FlexPane = MojitoPresentation.Components.FlexPane;
const Image = MojitoPresentation.Components.Image;
const Overlay = MojitoPresentation.Components.Overlay;
const Search = MojitoApplications.Sports.Search.SearchControllerView;
const IntentActionTrigger = MojitoPresentation.Base.Intent.IntentActionTrigger;

/**
 * This is an experimental page intended for use on mobile only. See details at: DBX-12195
 */
class SearchPageImpl extends UIViewImplementation {
    onSearchCloseClick() {
        IntentActionTrigger.showHomePage();
    }

    render() {
        const searchOverlay = UIViewUtils.getConfig('SearchOverlay');

        return (
            <Overlay config={searchOverlay.overlay}>
                <FlexPane config={searchOverlay.searchHeader}>
                    <Button onClick={this.onSearchCloseClick} class="ta-backButton">
                        <Image config={searchOverlay.searchBackButtonIcon} alt="back Button" />
                    </Button>
                    <Search initiallyActive={true} />
                </FlexPane>
            </Overlay>
        );
    }
}

export const SearchPage = UIPage('SearchPage', SearchPageImpl);
